import { combineReducers } from "@reduxjs/toolkit";
import { reducer as sideBarReducer } from "../slices/SideBar";
import { reducer as userReducer} from "../slices/slice";
import { reducer as SpareReducer} from "../slices/Spare";
import { reducer as ProductReducer} from "../slices/Product";
import { reducer as authReducer} from '../slices/LoginSlice';
import { reducer as GenerateQRReducer } from "../slices/GenerateQR";
import { reducer as memberReducer } from "../slices/MemberSlice";
import { reducer as dashboardReducer } from "../slices/MblApp";


const rootReducer = combineReducers({
  user:userReducer,
  spare: SpareReducer,
  product: ProductReducer,
  sideBar: sideBarReducer,
  auth: authReducer,
  QRCodeState: GenerateQRReducer,
  member: memberReducer,
  dashboard: dashboardReducer
});

export default rootReducer;
